// @flow
import * as React from 'react';
import Radium from 'radium';
import { Card, CardHeader, CardBlock } from 'reactstrap';

type Props = {
  communities: Array<string>,
};

class Community extends React.Component<Props> {
  render() {
    const { communities } = this.props;
    return (
      <Card style={styles.root}>
        <CardHeader style={styles.title}>Sichtbar in:</CardHeader>
        <CardBlock>
          <ul>
            {communities.map(community => <li key={community}>{community}</li>)}
          </ul>
        </CardBlock>
      </Card>
    );
  }
}

const styles = {
  root: {
    width: '100%',
  },
  title: {
    fontWeight: 'bold',
  },
};

export default Radium(Community);



// WEBPACK FOOTER //
// ./src/components/Community/Community.js